import { clockTime } from "@/lib/format";

import { measureParts } from "./measures";
import styles from "./Record.module.css";

export const NBSP = "\u00a0";

/**
 * The time column: `HH:MM` as tabular figures in the UI face (round-5 screen
 * check, R5-1 — a time is no measure, and mono set its zero with a slash);
 * the day stands in the day head above, the rest in `title`.
 */
export function EntryTime({ at, title }: { at: string; title: string }) {
  return (
    <time className={`tabular ${styles.time}`} dateTime={at} title={title}>
      {clockTime(at)}
    </time>
  );
}

/**
 * A sentence of the record with its measures in mono (CI §4, UX-Gutachten 1,
 * B-18; `measures.ts`): „Maß korrigiert · Wand 2: 1.100 mm" set the
 * millimetres in Roboto. Only the measures — the server's words stay as
 * they are.
 */
export function MeasureText({ text }: { text: string }) {
  return (
    <>
      {measureParts(text).map((part, index) =>
        part.measure ? (
          <span key={index} className="num">
            {part.text}
          </span>
        ) : (
          part.text
        ),
      )}
    </>
  );
}
